import { z } from "zod";

import { ACTION_RECEIPT_DISPOSITIONS } from "@/lib/actionRequests/actionReceipt";
import type { CNSActionReceipt } from "@/models/cns";

export const actionReceiptDispositionWireSchema = z.enum(
  ACTION_RECEIPT_DISPOSITIONS,
);

/** Canonical result persisted and authored by the Action Request backend. */
export const actionReceiptWireSchema = z
  .object({
    actionType: z.string().trim().min(1),
    disposition: actionReceiptDispositionWireSchema,
    data: z.record(z.string(), z.unknown()),
    summary: z.string().trim().min(1),
    status: z.string().trim().min(1),
    completedAt: z.iso.datetime({ offset: true }),
  })
  .strict() satisfies z.ZodType<CNSActionReceipt>;

/** Named schema for the completed workflow projection exposed by the generated REST contract. */
export const completedActionReceiptWireSchema = actionReceiptWireSchema.extend({
  completedAt: z.iso.datetime({ offset: true }),
});
